import { useCallback, useEffect, useRef, useState } from 'react';
import { haccpApi } from '../../haccpApi';

// Verbali DPI: mentre leggo DVR e attestati si aggiorna ogni 4 secondi; con la finestra aperta la lettura parte da sola se serve
export const useDpi = (attivo, aperto) => {
  const [dati, setDati] = useState(null);
  const timer = useRef(null);
  const avviato = useRef(false);
  const ricarica = useCallback(async () => {
    clearTimeout(timer.current);
    try {
      const r = await haccpApi.get('/documenti/dpi');
      setDati(r);
      if (r.in_corso) timer.current = setTimeout(ricarica, 4000);
    } catch { setDati((d) => (d && !d.errore_rete ? d : { errore_rete: true })); }
  }, []);
  const leggi = useCallback(async () => {
    avviato.current = true;
    try { await haccpApi.post('/documenti/dpi/leggi', {}); } finally { ricarica(); }
  }, [ricarica]);
  useEffect(() => { if (attivo) ricarica(); return () => clearTimeout(timer.current); }, [attivo, ricarica]);
  useEffect(() => {
    if (!aperto) { avviato.current = false; return; }
    if (dati?.dvr && dati.da_leggere && !dati.in_corso && !dati.errore && !avviato.current) leggi().catch(() => {});
  }, [aperto, dati, leggi]);
  return { dati, ricarica, leggi };
};
